import axios from "axios";
import router from "../router";
import _ from 'lodash'
export default {
    internet_status_on: function({commit}) {
	    commit("INTERNET_STATUS", true)
	},
	internet_status_off: function({commit}) {
	    commit("INTERNET_STATUS", false)
	},
	show_loading_screen: function({commit}) {
	    commit("DISPLAY_LOADING_SCREEN", true)
	},
	hide_loading_screen: function({commit}) {
	    commit("DISPLAY_LOADING_SCREEN", false)
	},
	set_games: function({commit}, payload) {
		commit("APPEND_TOP_GAME", payload)
	},
	set_gender: function({commit}, payload) {
		commit("SET_GENDER", payload)
	},
	set_newer: function({commit}, payload){
		commit("SET_NEWER", payload)
	},
	set_history: function({commit}, payload){
		commit("SET_HISTORY", payload)
	},
	removeById: function({commit}, payload){
		commit("REMOVE_GAME_BYID", payload)
	},
	fetch_data_game: function({state, commit}, payload){
		return new Promise(function(resolve, reject){
			commit("SET_CONTENTS", {})
			
			var v1 = Math.floor(Math.random() * (new Date()).getTime())
	        var url_data = state.urlJson + payload.language + "/data/" + payload.id + ".json?v=" + v1;
	        var url_data_try = state.urlJsonTry + payload.language + "/data/" + payload.id + ".json?v=" + v1;

	        axios.get(url_data)
	        .then(function(res) {
	        	commit("SET_CONTENTS", res.data)
	            window.gtag("event", "Load Json Success", {
	                event_category: "Load Json Success",
	                event_label: "Load app " + res.data.quiz.id + ".json - "+payload.language,
	                value: 1
	            });
	            window.scrollTo(0, 0);
	            resolve("ok")
	        }).catch(function(u) {
	            axios.get(url_data_try)
	            .then(function(response) {
	            	commit("SET_CONTENTS", response.data)
	            	window.scrollTo(0, 0);
	                window.gtag("event", "Load Json Success", {
	                    event_category: "Load Json Success",
	                    event_label: "Load app " + response.data.quiz.id + ".json - " + payload.language,
	                    value: 1
	                });
	                resolve("ok")    
	            }).catch(function(e) {
	                window.gtag("event", "Load Json Error", {
	                    event_category: "Load Json Error",
	                    event_label: state.userInfo.localeFb + "--" + url_data_try + "--" + e,
	                    value: 1
	                });
	                reject(e)
	                if (router.currentRoute.name !== "Home") {
	                    router.push({
	                        name: "Home"
	                    });
	                    commit("DISPLAY_LOADING_SCREEN", false);
	                }
	            });
	            window.gtag("event", "Load Json Error", {
	                event_category: "Load Json Error",
	                event_label: state.userInfo.localeFb + "--" + url_data + "--" + u,
	                value: 1
	            });
			})      
        })
	},
	fetch_top_games: function({state, commit}) {
	    commit("DISPLAY_LOADING_SCREEN", true);
	    var version = Math.floor((new Date()).getTime())
	    var url = state.urlHome + state.userInfo.locale + "/h1o1m@e1.json?v=" + version;
	    var url_try = state.urlHomeTry + state.userInfo.locale + "/h1o1m@e1.json"; //h1o1m@e1

	    axios.get(url).then(function(res) {
            var a = res.data;
            commit("APPEND_TOP_GAME", a)

            window.gtag("event", "Load Game success", {
                event_category: "Load Game success",
                event_label: url,
                value: 1
            });
        }).catch(function(err) {
        	window.gtag("event", "Game Err", {
                event_category: "Game Err",
                event_label: err,
                value: 1
            });
        	axios.get(url_try)
        	.then(function(response) {
	            var a = response.data;
	            commit("APPEND_TOP_GAME", a)

	            window.gtag("event", "Load Game try success", {
	                event_category: "Load Game try success",
	                event_label: url_try,
	                value: 1
	            });
	        }).catch(function() {
	        	router.push({
	                name: "Home"
	            })
	            commit("DISPLAY_LOADING_SCREEN", false);
	            window.gtag("event", "Load Game err", {
	                event_category: "Load Game err",
	                event_label: state.userInfo.locale,
	                value: 1
	            });
	        })
        })
	},
	fetch_top_homes: function({state, commit}) {
	    commit("DISPLAY_LOADING_SCREEN", true);

	    var url = state.urlHome + state.userInfo.locale + "/h1o1m@e1.json?v=" + state.version;
	    var url_try = state.urlHomeTry + state.userInfo.locale + "/h1o1m@e1.json";

	    axios.get(url).then(function(res) {
            var a = res.data;
            commit("APPEND_TOP_HOME", a)

            commit("DISPLAY_LOADING_SCREEN", false);

            window.gtag("event", "Load Home success", {
                event_category: "Load Home success",
                event_label: url,
                value: 1
            });
        }).catch(function(err) {
        	window.gtag("event", "Home Err", {
                event_category: "Home Err",
                event_label: err,
                value: 1
            });
        	axios.get(url_try)
        	.then(function(response) {
	            var a = response.data;
	            commit("APPEND_TOP_HOME", a)
	            commit("DISPLAY_LOADING_SCREEN", false);

	            window.gtag("event", "Load Home try success", {
	                event_category: "Load Home try success",
	                event_label: url_try,
	                value: 1
	            });
	        }).catch(function() {
	        	router.push({
	                name: "Home"
	            })
	            commit("DISPLAY_LOADING_SCREEN", false);
	            window.gtag("event", "Load Home err", {
	                event_category: "Load Home err",
	                event_label: state.userInfo.locale,
	                value: 1
	            });
	        })
        })
	}

}

